"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AbstractApi = void 0;

var Countries_1 = require("./Api/DateTime/Countries");

var DateTimeZone_1 = require("./Api/DateTime/DateTimeZone");

var TypeFactory_1 = require("./Api/Type/TypeFactory");

var USAStates_1 = require("./Api/DateTime/USAStates");

var UseCaseFactory_1 = require("./Api/UseCase/UseCaseFactory");

var AbstractApi =
/** @class */
function () {
  function AbstractApi(apiBaseUri) {
    if (apiBaseUri === void 0) {
      apiBaseUri = 'https://eventfarm.com/api/v2';
    }

    this.apiBaseUri = apiBaseUri;
    this.dateTimeFactory = new DateTimeZone_1.DateTimeZone();
    this.usaStateList = new USAStates_1.USAState();
    this.countryList = new Countries_1.Countries();
    this.typeFactory = new TypeFactory_1.TypeFactory();
  }

  Object.defineProperty(AbstractApi.prototype, "useCaseFactory", {
    get: function get() {
      return new UseCaseFactory_1.UseCaseFactory(this.eventFarmRestClient);
    },
    enumerable: false,
    configurable: true
  });
  return AbstractApi;
}();

exports.AbstractApi = AbstractApi;